import { inject } from 'vue'
import { storeToRefs } from 'pinia'
import * as yup from 'yup'
import { useTrustyStore } from '@/stores/data/trustyComplete'

export function useValidationSchema() {
  const regexLink = inject('regexLink')
  const regexIsHttps = inject('regexIsHttps')
  const regexNameField = inject('regexNameField')
  const trustyStore = useTrustyStore()
  const { pathStartFinish } = storeToRefs(trustyStore)

  const validationSchema = {
    email: yup
      .string()
      .required()
      .email()
      .max(230)
      .matches(regexIsHttps, { excludeEmptyString: true })
      .matches(regexLink, { excludeEmptyString: true }),
    first_name: yup
      .string()
      .required()
      .max(50)
      .matches(regexNameField, { excludeEmptyString: true })
      .matches(regexIsHttps, { excludeEmptyString: true })
      .matches(regexLink, { excludeEmptyString: true }),
    last_name: yup
      .string()
      .required()
      .max(50)
      .matches(regexNameField, { excludeEmptyString: true })
      .matches(regexIsHttps, { excludeEmptyString: true })
      .matches(regexLink, { excludeEmptyString: true }),
    hours: yup.number().required().max(10),
    pickup: yup
      .string()
      .required()
      .max(230)
      .test(
        'google-complete',
        'Address must be verified using Google Autocomplete, and the country must be within the European Union or Switzerland',
        () => {
          if (pathStartFinish.value.ride_history) return true
          if (pathStartFinish.value.redis_id) return true
          return pathStartFinish.value.valid.pickup
        }
      )
      .matches(regexIsHttps, { excludeEmptyString: true })
      .matches(regexLink, { excludeEmptyString: true }),
    dropoff: yup
      .string()
      .required()
      .max(230)
      .test(
        'google-complete',
        'Address must be verified using Google Autocomplete, and the country must be within the European Union or Switzerland',
        () => {
          if (pathStartFinish.value.ride_history) return true
          if (pathStartFinish.value.redis_id) return true
          return pathStartFinish.value.valid.dropoff
        }
      )
      .matches(regexIsHttps, { excludeEmptyString: true })
      .matches(regexLink, { excludeEmptyString: true })
  }

  return {
    validationSchema
  }
}
